import { render, staticRenderFns } from "./projectContent.vue?vue&type=template&id=5104bafc&scoped=true&"
import script from "./projectContent.vue?vue&type=script&lang=js&"
export * from "./projectContent.vue?vue&type=script&lang=js&"
import style0 from "./projectContent.vue?vue&type=style&index=0&id=5104bafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104bafc",
  null
  
)

export default component.exports